/**
 * Utility functions for chart data processing and calculations.
 */

/**
 * Computes the minimum value from an array of datasets.
 */
export function getMinValue(datasets: { label: string; data: (number | null)[] }[]): number {
    const values = datasets.flatMap(dataset => dataset.data).filter((v): v is number => v !== null && !isNaN(v));
    return values.length > 0 ? Math.min(...values) : 0;
}

/**
 * Computes the maximum value from an array of datasets.
 */
export function getMaxValue(datasets: { label: string; data: (number | null)[] }[]): number {
    const values = datasets.flatMap(dataset => dataset.data).filter((v): v is number => v !== null && !isNaN(v));
    return values.length > 0 ? Math.max(...values) : 0;
}

/**
 * Normalizes a value to a given range.
 * 
 * @param value - The value to normalize
 * @param min - The minimum value of the input range
 * @param max - The maximum value of the input range
 * @param scaledMin - The minimum value of the output range
 * @param scaledMax - The maximum value of the output range
 * @returns The normalized value
 */
export function normalize(
    value: number,
    min: number,
    max: number,
    scaledMin: number,
    scaledMax: number
): number {
    return ((value - min) / (max - min)) * (scaledMax - scaledMin) + scaledMin;
}
